import { ClassificacaoFilter } from './classificacao-filter';

export class ClassificacaoFilterStorage {
    filter: ClassificacaoFilter;
    filterValues: Map<string, any>;

    constructor(filter: ClassificacaoFilter) {
        this.filter = filter;
        this.filterValues = new Map();
    }
}
